import { Link } from "react-router-dom";
import { Reveal, Eyebrow } from "@/components/Reveal";
import CheckoutButton from "@/components/CheckoutButton";

export const FinalCTA = () => (
  <section id="start" className="relative py-28 sm:py-40 overflow-hidden">
    <div
      className="absolute inset-0 pointer-events-none"
      style={{
        background:
          "radial-gradient(55% 60% at 50% 100%, rgba(212,175,55,0.12), transparent 70%)",
      }}
    />
    <div className="relative max-w-4xl mx-auto px-5 sm:px-8 text-center">
      <Reveal>
        <Eyebrow>Get Started</Eyebrow>
        <h2 className="font-display text-3xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white mt-5 leading-[1.05]">
          Ready to Grow Your Business?
        </h2>
        <p className="text-slate-400 mt-6 max-w-xl mx-auto leading-relaxed">
          You don't have to purchase everything at once. Start by understanding where your business
          is today and what should happen next.
        </p>
      </Reveal>

      <Reveal delay={0.12}>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-5 mt-11">
          <CheckoutButton
            lookup="aih_full_assessment"
            label="Get My Business Assessment — $99.99"
            testid="final-cta-assessment"
            className="w-full sm:w-auto px-9 py-5 rounded-full bg-gold text-obsidian font-display font-bold hover:bg-gold-bright hover:-translate-y-0.5 transition-all duration-300 gold-ring"
          />
          <span className="text-slate-500 text-sm">or</span>
          <Link
            to="/intake?type=consultation"
            data-testid="final-cta-consultation"
            className="w-full sm:w-auto px-9 py-5 rounded-full border border-slate-600 text-slate-200 font-display font-bold hover:border-gold hover:text-gold transition-colors duration-300"
          >
            Schedule a Consultation
          </Link>
        </div>
        <p className="text-slate-500 text-xs mt-8">
          Eligible purchases are protected by our 7-Day Money-Back Guarantee.
        </p>
      </Reveal>
    </div>
  </section>
);

export default FinalCTA;
